import { useEffect, useRef } from "react";

export const StarfieldCanvas = ({ className = "" }) => {
  const canvasRef = useRef(null);

  useEffect(() => {
    const canvas = canvasRef.current;
    const c = canvas.getContext("2d");
    let w, h, raf;
    const dpr = Math.min(window.devicePixelRatio || 1, 2);
    let stars = [];
    let lanterns = [];
    let shooting = null;
    let lastShot = 0;

    const resize = () => {
      w = canvas.clientWidth;
      h = canvas.clientHeight;
      canvas.width = w * dpr;
      canvas.height = h * dpr;
      c.setTransform(dpr, 0, 0, dpr, 0, 0);
      stars = Array.from({ length: Math.floor((w * h) / 4500) }, () => ({
        x: Math.random() * w,
        y: Math.random() * h * 0.85,
        r: 0.4 + Math.random() * 1.4,
        p: Math.random() * Math.PI * 2,
        s: 0.6 + Math.random() * 1.6,
      }));
      lanterns = Array.from({ length: 5 }, () => ({
        x: Math.random() * w,
        y: h + Math.random() * h,
        v: 0.15 + Math.random() * 0.25,
        r: 2.5 + Math.random() * 2.5,
        drift: Math.random() * Math.PI * 2,
      }));
    };

    const draw = (t) => {
      c.clearRect(0, 0, w, h);

      for (const s of stars) {
        const a = 0.35 + 0.65 * Math.abs(Math.sin(t / 900 / s.s + s.p));
        c.beginPath();
        c.arc(s.x, s.y, s.r, 0, Math.PI * 2);
        c.fillStyle = `rgba(243, 229, 171, ${a})`;
        c.shadowColor = "rgba(243,229,171,0.9)";
        c.shadowBlur = 6;
        c.fill();
        c.shadowBlur = 0;
      }

      for (const l of lanterns) {
        l.y -= l.v;
        l.x += Math.sin(t / 2000 + l.drift) * 0.2;
        if (l.y < -20) {
          l.y = h + 20;
          l.x = Math.random() * w;
        }
        const g = c.createRadialGradient(l.x, l.y, 0, l.x, l.y, l.r * 5);
        g.addColorStop(0, "rgba(244, 211, 160, 0.85)");
        g.addColorStop(1, "rgba(244, 211, 160, 0)");
        c.beginPath();
        c.arc(l.x, l.y, l.r * 5, 0, Math.PI * 2);
        c.fillStyle = g;
        c.fill();
        c.beginPath();
        c.arc(l.x, l.y, l.r, 0, Math.PI * 2);
        c.fillStyle = "rgba(255, 226, 170, 0.95)";
        c.fill();
      }

      if (!shooting && t - lastShot > 5500 && Math.random() < 0.01) {
        shooting = { x: Math.random() * w * 0.7 + w * 0.2, y: Math.random() * h * 0.3, life: 0 };
        lastShot = t;
      }
      if (shooting) {
        shooting.life += 1;
        shooting.x += 9;
        shooting.y += 3.4;
        const alpha = Math.max(0, 1 - shooting.life / 55);
        c.beginPath();
        c.moveTo(shooting.x, shooting.y);
        c.lineTo(shooting.x - 60, shooting.y - 22);
        c.strokeStyle = `rgba(255, 250, 220, ${alpha})`;
        c.lineWidth = 1.6;
        c.stroke();
        if (shooting.life > 55) shooting = null;
      }

      raf = requestAnimationFrame(draw);
    };

    resize();
    raf = requestAnimationFrame(draw);
    window.addEventListener("resize", resize);
    return () => {
      cancelAnimationFrame(raf);
      window.removeEventListener("resize", resize);
    };
  }, []);

  return <canvas ref={canvasRef} className={`pointer-events-none ${className}`} aria-hidden="true" />;
};
